import React, { useEffect, useState } from 'react';
import deThiTracNghiem from '../../api/de';
import Confetti from 'react-confetti';
import { FaRedo, FaArrowLeft } from 'react-icons/fa';
import './style.scss';

const getEmoji = (score, total) => {
  const percent = score / total;
  if (percent === 1) return '🏆';
  if (percent >= 0.8) return '🎉';
  if (percent >= 0.5) return '😊';
  return '😅';
};

const QuizResult = ({ quizId, userAnswers, score, onRetry, onBack }) => {
  const quiz = deThiTracNghiem.find((d) => d.id === quizId);
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (score / quiz.cauHoi.length >= 0.8) setShowConfetti(true);
    else setShowConfetti(false);
  }, [score, quiz.cauHoi.length]);

  // Xóa điểm khi làm lại
  const handleRetry = () => {
    localStorage.removeItem(`quiz_score_${quizId}`);
    onRetry();
  };

  return (
    <div className="quiz-result-bg">
      {showConfetti && <Confetti />}
      <div className="quiz-result-emoji">{getEmoji(score, quiz.cauHoi.length)}</div>
      <div className="quiz-result-score rainbow-text">
        Bạn được {score} / {quiz.cauHoi.length} điểm
      </div>
      <div className="quiz-result-detail">
        {quiz.cauHoi.map((q, idx) => {
          const userAns = userAnswers[idx]?.answer;
          const isCorrect = userAns === q.cauTraLoiDung;
          return (
            <div key={q.id} className={`quiz-result-item ${isCorrect ? 'correct' : 'wrong'}`}>
              <span className="quiz-result-q">Câu {idx + 1}:</span>
              <span className="quiz-result-user">{userAns || '—'}</span>
              <span className="quiz-result-right">{isCorrect ? '✔️' : '❌'}</span>
            </div>
          );
        })}
      </div>
      <div className="quiz-result-actions">
        <button className="quiz-retry-btn" onClick={handleRetry}><FaRedo /> Làm lại</button>
        <button className="quiz-back-btn" onClick={onBack}><FaArrowLeft /> Chọn đề khác</button>
      </div>
    </div>
  );
};

export default QuizResult; 